module.exports = __webpack_public_path__ + "static/media/01-3-x-copy-3@3x.fd0eb683.png";